import { useQuery } from "@tanstack/react-query"
import { getDashboardStatistics } from "../api/statistics"

const useDashboardStatistics = (params = {}) => {
  const { from, to, patientIssuer } = params

  return useQuery({
    queryKey: ["dashboard-statistics", from, to, patientIssuer],
    queryFn: () => getDashboardStatistics({ from, to, patientIssuer }),
    retry: false,
  })
}

export default useDashboardStatistics
